<template>
<v-layout
    class="patient-page"
    column
  >
        <v-data-table
        style="width:100%"
          v-if="files"
          :headers="headers"
          :items="files"
          sort-icon=""
          class="flat table-border pa-0"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="currentPagination"
          :total-items="totalItems"
          @update:pagination="updatePagination"
        >
          <!-- :search="search" -->
          <template
            slot="items"
            slot-scope="props"
          >
            <tr style="cursor: pointer;" :class="alternatingColors(props.index)" @click="goToDocumentPage(props.item.id)">
              <td>{{ props.item.id }}</td>
              <td>{{ convertDate(props.item.created) }}</td>
              <td>{{ props.item.faxedFrom }}</td>
            </tr>
          </template>
        </v-data-table>

        <v-progress-circular
          v-else
          :size="200"
          :width="15"
          color="primary"
          indeterminate
          class="centered"
        ></v-progress-circular>
</v-layout>
</template>


<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AdminDocumentsPage',
  data() {
    return {
      headers: [
        {
          text: 'Document ID'
        },
        {
          text: 'Creation Date'
        },
        {
          text: 'Faxed From'
        }
      ],
      rowsPerPageItems: [25, 50, 100],
      currentPagination: {
        rowsPerPage: 25
      }
    }
  },
  methods: {
    ...mapActions('admin', ['getFiles']),
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate'
      } else {
        return 'grayAlternate'
      }
    },
    goToDocumentPage(id) {
      this.$router.push({
        name: 'AdminDocumentPage',
        params: { id }
      })
    },
    updatePagination(pag) {
      this.getFiles({
        limit: this.currentPagination.rowsPerPage,
        offset: (pag.page - 1) * pag.rowsPerPage
      })

      console.log('update:pagination', pag)
    }
  },
  computed: {
    ...mapState('admin', ['files', 'totalItems', 'pagination'])
  },
  // watch: {
  //   currentPagination(amount) {
  //     this.getFiles({ limit: this.currentPagination.rowsPerPage })
  //   }
  // },
  mounted() {
    this.getFiles({ limit: this.currentPagination.rowsPerPage })
  }
}
</script>


<style lang="scss" scoped>
.table-border {
  border: 1px solid #f5f5f5;
}

.center {
  margin: auto;
  width: 100%;
}

.centered {
  position: fixed;
  top: 35%;
  left: 50%;
}

.admin-title {
  font-size: 18px;
  font-weight: 400;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
</style>





// WEBPACK FOOTER //
// src/pages/admin/AdminDocumentsPage.vue